import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { RateService } from '../../house-order-detail/rate-detail/rate.service';
import _ from 'lodash';
type PageType = 'rate' | 'reply';

@Component({
  selector: 'host-edit-rate',
  templateUrl: './edit-rate.component.html',
  styleUrls: ['./edit-rate.component.scss']
})
export class EditRateComponent implements OnInit {

  @Input() pageType: PageType = 'rate';
  @Input() code;
  @Input() score;
  content = '';
  constructor(
    private rateService: RateService,
    private modalRef: NzModalRef
  ) { }

  ngOnInit() {
  }

  requestSendRate () {
    const params = {
      reservation_order_code: this.code,
      score: this.score,
      content: this.content,
    };
    this.rateService.sendRate(params).subscribe(res => {
      console.log('res: ', res);
      if (res.error_code === 0) {
        this.close();
      }
    });
  }

  requestSendReply () {
    const params = {
      reservation_order_code: this.code,
      content: this.content,
    };
    this.rateService.sendReply(params).subscribe(res => {
      console.log('res: ', res);
      if (res.error_code === 0) {
        this.close();
      }
    });
  }

  requestReplaceDynContent (content: string) {
    const params = {
      reservation_order_code: this.code,
      content
    };
    this.rateService.replaceDynContent(params).subscribe(res => {
      const content = _.get(res, 'data.content');
      this.content = content;
    });
  }

  onSelectQuickRate (tpl) {
    const content = tpl ? tpl.content : null;
    if (content) {
      this.requestReplaceDynContent(content);
    } else {
      this.content = content;
    }
  }

  onSave () {
    if (this.pageType === 'rate') {
      this.requestSendRate();
    } else {
      this.requestSendReply();
    }
  }

  onCancel () {
    this.close();
  }

  private close () {
    this.modalRef.destroy();
  }

}
